import {
  BadRequestException,
  ConflictException,
  ForbiddenException,
  InternalServerErrorException,
  NotFoundException,
  UnauthorizedException,
} from '@nestjs/common';

import { ErrorCode } from '../enums';
import { envIsDev } from '../util';

// Note: this is the only "normal" place where exceptions are allowed

/***
 * returns a {@link BadRequestException} with the provided {@link ErrorCode}.
 * @param errorCode
 * @param description
 * @returns { BadRequestException }
 */
export function badRequestException(
  errorCode: ErrorCode,
  description?: string | object,
) {
  return new BadRequestException(responseObject(errorCode, description));
}

/***
 * returns a {@link ConflictException} with the provided {@link ErrorCode}.
 * @param description
 * @returns { HttpException }
 */
export function conflictException(
  errorCode: ErrorCode,
  description?: string | object,
) {
  return new ConflictException(responseObject(errorCode, description));
}

/***
 * returns a {@link ForbiddenException} with the provided {@link ErrorCode}.
 * @returns { ForbiddenException }
 */
export function forbiddenException() {
  return new ForbiddenException(responseObject(ErrorCode.NotAllowed));
}

/***
 * returns an {@link InternalServerErrorException} with the provided {@link ErrorCode}.
 * @param errorCode
 * @param description
 * @returns { InternalServerErrorException }
 */
export function internalException(
  errorCode?: ErrorCode,
  description?: string | object,
) {
  return new InternalServerErrorException(
    responseObject(errorCode ?? ErrorCode.DefaultError, description),
  );
}

/***
 * returns an {@link UnauthorizedException} with the provided {@link ErrorCode}.
 * @param errorCode
 * @param description
 * @returns { UnauthorizedException }
 */
export function unauthorizedException(
  errorCode: ErrorCode,
  description?: string | object,
) {
  return new UnauthorizedException(responseObject(errorCode, description));
}

/***
 * returns a {@link NotFoundException} with the provided {@link ErrorCode}.
 * @param errorCode
 * @param description
 * @returns { NotFoundException }
 */
export function notFoundException(
  errorCode: ErrorCode,
  description?: string | object,
) {
  return new NotFoundException(responseObject(errorCode, description));
}

function responseObject(errorCode: ErrorCode, description?: string | object) {
  let responseObject: Record<string, unknown> = {
    errorCode,
  };
  // do not send details in staging/prod
  if (!envIsDev()) description = undefined;

  if (description !== null && typeof description === 'string') {
    responseObject = {
      message: description,
      ...responseObject,
    };
  } else if (description !== null && typeof description === 'object') {
    responseObject = {
      ...description,
      ...responseObject,
    };
  }
  return responseObject;
}
